"use strict";

var TABLE_ALIGN = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center"
};
module.exports = TABLE_ALIGN;